// src/prompts/templates/generateTitle.ts
var generateTitlePrompt = [
  "You are an expert real estate copywriter.",
  "Given a property description and type, generate a short, catchy listing title.",
  'Respond with ONLY valid JSON in this exact format: {"title": "..."}',
  "Keep the title under 10 words."
].join("\n");

export {
  generateTitlePrompt
};
